import { useMutation } from '@tanstack/react-query';

import { RequestAccessAPI } from '../index';
import { GrantAccessBody, directoryType } from '../types';
import { DIRECTORY_TYPE } from '../../constants';

const useGrantAccess = (directoryType: directoryType = DIRECTORY_TYPE.GOOGLE) => {
    const { mutate, mutateAsync, isPending } = useMutation({
        mutationFn: (body: GrantAccessBody) => RequestAccessAPI.grantAccess(directoryType, body),
    });

    return {
        mutate,
        mutateAsync,
        isPending,
    };
};

export { useGrantAccess };
